<template>
  <div class="body">
    <b-container class="analysis-config">
      <div class="mb-3">
        <label class="mr-3 date-item d-flex">{{ $t('data-hora-da-analise') }} </label>
        <div class="alignFlex">
          <date-picker
            id="date-picker"
            class="adjustDatePickers"
            ref="datePickerStart"
            name="date"
            v-model="analysisTimestamp"
            :config="optionsDatePicker"
          ></date-picker>
          <i class="fa fa-calendar fa-lg ml-2" aria-hidden="true"></i>
        </div>
      </div>
      <div>
        <div>
          <label class="mr-3">{{ $t('produto') }}</label>
          <b-form-select
            class="input-pentagro"
            name="productId"
            id="productId"
            v-model="productId"
            v-validate="{ required: true }"
            :options="products"
            value-field="id"
            text-field="description"
            disabled-field="notEnabled"
          >
          </b-form-select>
        </div>
      </div>
      <div>
        <div>
          <label class="mr-3">{{ $t('processo-0') }}</label>
          <b-form-select
            class="input-pentagro"
            name="processId"
            id="processId"
            v-model="processId"
            :disabled="process.length < 2"
            v-validate="{ required: true }"
            :options="process"
            value-field="id"
            text-field="description"
            disabled-field="notEnabled"
          >
          </b-form-select>
        </div>
      </div>
      <div>
        <div>
          <label class="mr-3">{{ $t('equipamento-0') }}</label>
          <b-form-select
            class="input-pentagro"
            name="equipmentId"
            id="equipmentId"
            v-model="equipmentId"
            v-validate="{ required: true }"
            :disabled="equipments.length < 2"
            :options="equipments"
            value-field="id"
            text-field="description"
            disabled-field="notEnabled"
          >
          </b-form-select>
        </div>
      </div>
      <div>
        <div class="mt-2">
          <label class="mr-3">{{ $t('grandezas-0') }}</label>
          <div class="gridGreatness grid1 middle"></div>
        </div>
      </div>
      <div class="groupBtn mt-4">
        <div>
          <img
            src="@/assets/salvar.png"
            :alt="$t('salvar')"
            style="margin-left: 20px"
            :title="$t('salvar')"
            @click="addAnalysis"
          />
          <img
            id="closeModalPassword"
            class="float-right"
            src="@/assets/sair.png"
            style="margin-right: 15px; margin-left: 20px"
            :title="$t('sair')"
            :alt="$t('sair')"
            @click="$bvModal.hide('newAnalysis')"
          />
        </div>
      </div>
    </b-container>
    <!-- <PageTitle main="Lançamento de Análises" sub imagem="dashboard.png" />
    <div class="container">
      <div class="row-flex">
        <div></div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { AnalysisDataMixin } from "./AnalysisDataMixin";
import * as cGridAll from "vue-cheetah-grid";
import * as cheetahGrid from "cheetah-grid";
import { defaultSuccess, urlMainAPI, emitEventBuss } from "@/global";
import axios from "axios";

var inputEditor = new cheetahGrid.columns.action.InlineInputEditor();

const { INPUT_CELL } = cheetahGrid.ListGrid.EVENT_TYPE;

export default {
  name: "newAnalysis",

  components: { ...cGridAll },

  mixins: [AnalysisDataMixin],

  data: function () {
    return {
      productId: null,
      processId: null,
      equipmentId: null,
      products: [
        {
          id: null,
          description: this.$t('selecione-um-produto-0'),
        },
      ],
      process: [
        {
          id: null,
          description: this.$t('selecione-um-processo-0'),
        },
      ],
      equipments: [
        {
          id: null,
          description: this.$t('selecione-um-equipamanto'),
        },
      ],
      greatness: [],
      temp: [],
      greatnessToAnalysis: [],
      header: [
        {
          field: "nameAndUnit",
          caption: this.$t('nome-unidade-de-medida'),
          action: "text",
          width: "50%",
          maxWidth: "100%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse" },
        },
        {
          field: "range",
          caption: this.$t('range-de-operacao'),
          action: "text",
          width: "25%",
          maxWidth: "50%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse", textAlign: "center" },
        },
        {
          field: "value",
          caption: this.$t('valor'),
          action: inputEditor,
          width: "23%",
          maxWidth: "46%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          message(rec) {
            if (isNaN(parseFloat(rec.value)) && rec.value && rec.value != 0)
              return "Por favor, digite apenas número.";
            return null;
          },
          style(rec) {
            let checkValue = (value) => {
              if (value || value == 0) {
                return parseFloat(value.replace(",", "."));
              }
            };

            let range = [];
            let min = "";
            let max = "";
            let value = 0;

            if (rec.range.includes(" - ")) {
              range = rec.range.split(" - ");
              if (range.length == 2) {
                min = checkValue(range[0]);
                max = checkValue(range[1]);
              }
            } else {
              if (rec.range.includes("<=")) {
                max = rec.range.split("<= ")[1];
              } else {
                min = rec.range.split(">= ")[1];
              }
            }
            value = checkValue(rec.value);

            if ((min != "" && value < min) || (max != "" && value > max)) {
              return {
                color: "red",
                font: "18px sans-serif",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },
        },
      ],
    };
  },

  watch: {
    async productId(data) {
      let greatnessAux = this.temp.filter((x) => x.productId == data);
      this.process = [];

      greatnessAux.forEach((element) => {
        let obj_proc = {
          id: element.processId,
          description: element.process,
        };
        if (!this.process.find((a) => a.id == obj_proc.id)) {
          this.process.push(obj_proc);
        }
      });
      this.processId = null;
      this.process.unshift({
        id: null,
        description: this.$t('selecione-um-processo-0'),
      });
      this.equipmentId = null;
      this.equipments = [
        {
          id: null,
          description: this.$t('selecione-um-equipamento-0'),
        },
      ];
      this.greatnessToAnalysis = [];
      this.setGrid();
    },

    async processId(data) {
      let greatnessAux = this.temp.filter(
        (x) => x.productId == this.productId && x.processId == data
      );
      this.equipmentId = null;
      this.equipments = [];

      greatnessAux.forEach((element) => {
        let obj_equi = {
          id: element.equipmentId,
          description: element.equipment,
        };

        if (!this.equipments.find((a) => a.id == obj_equi.id)) {
          this.equipments.push(obj_equi);
        }
      });

      this.equipments.unshift({
        id: null,
        description: this.$t('selecione-um-equipamento-0'),
      });

      this.greatnessToAnalysis = [];
      this.setGrid();
    },

    async equipmentId(data) {
      if (data != null) {
        this.greatnessToAnalysis = [];
        await this.loadGreatness();
        this.setGrid(this.greatnessToAnalysis);
      }
    },
  },

  methods: {
    addAnalysis() {
      let analysesData = [];

      this.greatnessToAnalysis.forEach((gta) => {
        const parentesesMatches = [...gta.nameAndUnit.matchAll(/\(([^)]+)\)/g)]
        
        if (gta.nameAndUnit != null) {
          let analysisToSave = {
            productId: this.productId,
            equipmentId: this.equipmentId,
            processId: this.processId,
            greatness:
              gta.nameAndUnit.includes("(") && parentesesMatches.length > 0 ? gta.nameAndUnit.replace(parentesesMatches[parentesesMatches.length - 1 ][0],"").trim() :  gta.nameAndUnit,
            analysisTimestamp: this.formatBaseDate(this.analysisTimestamp)
              .replace("T", " ")
              .replace("-03:00", ""),
            value:
              gta.value == undefined
                ? null
                : parseFloat(gta.value.replace(",", ".")),
          };
          analysesData.push(analysisToSave);          
        }
      });

      if (!this.canSave(analysesData, 1)){
        this.clearField()
        return;
      }
      

      const url = `${urlMainAPI}/saveanalysisdata`;

      defaultSuccess(this.$t('salvando-dados'));
      axios.post(url, analysesData).then(() => {
        defaultSuccess(this.$t('dados-inseridos-com-sucesso'));
        this.clearField();
      });
    },
    
    clearField() {
      this.greatnessToAnalysis.forEach((element) => {
        element.value = null;
      });
      this.setGrid();
    },

    createGrid() {
      const grid = new cheetahGrid.ListGrid({
        parentElement: document.querySelector(".gridGreatness"),
        allowRangePaste: true,
        header: this.header,
      });

      grid.records = this.greatnessToAnalysis;

      grid.listen(INPUT_CELL, (...args) => {
        if (
          args[0].row == this.greatness.length &&
          !this.greatness[this.greatness.length - 1].name
        ) {
          this.setGrid();
        }
      });

      this.setGrid = function (table = this.greatnessToAnalysis) {
        if (table.length > 0 && !table[table.length - 1].nameAndUnit)
          this.addLine();
        grid.records = table;
      };
    },

    addLine(param) {
      this.greatnessToAnalysis.push({
        nameAndUnit: param,
        range: "",
        value: null,
      });
    },

    async loadGreatness() {
      const url = `${urlMainAPI}/getgreatness/${this.productId}/${this.processId}/${this.equipmentId}`;

      await axios.get(url).then(async (res) => {
        this.greatness = await res.data;
      });

      for (let index = 0; index < this.greatness.length; index++) {
        let analyse = {};
        analyse.nameAndUnit = `${this.greatness[index].name} (${this.greatness[index].unit})`;

        let range =
          this.greatness[index].lowerThreshould == -9999
            ? `<= ${this.greatness[index].upperThreshould}`
            : "";
        range =
          this.greatness[index].upperThreshould == -9999
            ? `>= ${this.greatness[index].lowerThreshould}`
            : range;
        range =
          range == ""
            ? `${this.greatness[index].lowerThreshould} - ${this.greatness[index].upperThreshould}`
            : range;

        analyse.range = range;

        this.greatnessToAnalysis.push(analyse);
      }
    },

    async loadGreatnessForAnalysis() {
      const url = `${urlMainAPI}/getgreatnessforanalysis`;

      await axios.get(url).then((res) => {
        this.temp = res.data;
      });
    },

    async loadProducts() {
      this.temp.forEach((element) => {
        let obj_prod = {
          id: element.productId,
          description: element.product,
        };
        if (!this.products.find((a) => a.id == obj_prod.id)) {
          this.products.push(obj_prod);
        }
      });
    },
  },

  async created() {
    await this.loadGreatnessForAnalysis();
    await this.loadProducts();
    this.createGrid();
  },

  destroyed() { 
    emitEventBuss("reloadGridAnalysis")
  },
};
</script>

<style scoped>
.body {
  margin: 8px;
}

.analysis-config {
  border-radius: 4px;
  box-shadow: 1px 1px 2px 1px #00000030;
  padding: 8px;
  margin-bottom: 5px;
}

.grid1 {
  height: calc(63vh - 220px);
  width: 100%;
  border: solid 1px rgba(0, 0, 0, 0.26);
  overflow-x: hidden;
  overflow-y: auto;
}

.row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
  /* margin-right: 70px; */
}

.group {
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}

.gridBtGroup {
  margin: 30px auto auto auto;
  width: 80vw;
  display: flex;
  justify-content: flex-end;
}

.ybase {
  /* margin-right: 20px; */
  margin-top: 20x;
}

.gridBtGroup img {
  cursor: pointer;
  max-height: 45px;
}

/* Copiando a FaultTreeManagement */

.table,
.indicator-select,
.fault-tree {
  max-height: 155px;
  overflow-x: auto;
  border: 1px solid #00000013;
  border-radius: 4px;
  box-shadow: 2px 2px 2px #00000013;
}

.fault-tree {
  overflow-x: none;
  max-height: 600px;
  padding: 10px;
}

.indicator-select {
  margin-bottom: 15px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

img,
.copy {
  cursor: pointer;
  max-height: 35px;
}

.copy {
  height: 35px;
  width: 35px;
  color: #ff7100;
  transition-delay: 600ms;
}

.field-selected {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 15px;
  max-height: 100px;
  overflow-y: auto;
}

.lines-selected {
  background-color: #00000013;
  padding: 0 3px;
  margin: 2px 5px;
  border-radius: 3px;
}

.btn-clear {
  cursor: pointer;
}

.alignFlex {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55%;
}
</style>